import { shoppingApi } from '@/helpers/apis';
import axios from '@/helpers/axios';

export const requestCartList = (userInfo, currentAccount) => {
  const url = shoppingApi.SHOPPINGCARTS_LIST;
  const payload = { email: userInfo.email, brn: currentAccount.brn };
  return axios.post(url, payload);
};

export const requestDeleteCart = (cartIdList) => {
  const url = shoppingApi.SHOPPINGCARTS_DEACTIVATE;
  const payload = { shoppingCartIds: cartIdList };
  return axios.post(url, payload);
};
